import il_mechanic from '@/assets/images/illustrations/mechanic.svg';
import { Modal } from '@/components/shared';
import { PacmanLoading } from '@/components/shared/loading/pacman-loading';
import { bem } from '@/utilities';
import React from 'react';

type Props = {
  openModal: boolean;
};

export const LoadingAdjustmentModal: React.FC<Props> = (props) => {
  const { openModal } = props;

  if (!openModal) return <></>;

  return (
    <Modal isOpen={openModal}>
      <h2 className={bem('loading-adjustment-modal', 'title')}>日時調整中</h2>
      <p className={bem('loading-adjustment-modal', 'text')}>お伺いする日時を調整してます</p>
      <div className={bem('loading-adjustment-modal', 'loading')}>
        <PacmanLoading />
      </div>
      <div className={bem('loading-adjustment-modal', 'image')}>
        <img src={il_mechanic} />
      </div>
    </Modal>
  );
};
